













































































































































































import IosSelectMini from './iosSelect.vue';

export default {
	name: 'filtros',
	inject: ['responsive'],
	components: { IosSelectMini },
	props: {
		modulo: {
			type: String,
		},
	},
	data() {
		return {
			filter: {
				patron: '',
				familia_id: '',
				subfamilia_id: '',
				unidad: '',
				negocio_id: '',
				presentacion_id: '',
				rubro_id: '',
				subrubro_id: '',
				linea_id: '',
				marca_id: '',
				es_nuevo: false,
				es_promocion: false,
			},
			loadingSelect: false,
			//patron: '',
			start: 0,
			limit: 12,
			page: 1,
			visibleTable: true,
			visibleCarrito: false,
			dashboard: true,
			historial: false,
		};
	},
	watch: {
		visible(v) {
			this.show = !this.show;
		},
		cardactivo(v) {
			this.activo = v;
		},
		/*filter(filter) {
			//this.$store.dispatch('saveFilter', filter);
			this.$store.dispatch('saveFilter', this.filter).then(() => {
				this.$store.dispatch('loadAllProductos').then(() => {});
			});
		},*/
	},
	computed: {
		tituloResumen() {
			return this.$route.name;
		},
		productos() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.productos;
			else return this.$store.state.pedidos.productos;
		},
		total() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.total;
			else return this.$store.state.pedidos.total;
		},
		unidades() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.unegocio;
			else return this.$store.state.pedidos.unegocio;
		},
		familia() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.familia;
			else return this.$store.state.pedidos.familia;
		},
		subfamilia() {
			if (this.modulo === 'ocompra') {
				return this.$store.state.ordenescompra.subfamilia;
			} else return this.$store.state.pedidos.subfamilia;
		},
		presentacion() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.presentacion;
			else return this.$store.state.pedidos.presentacion;
		},
		rubro() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.rubro;
			else return this.$store.state.pedidos.rubro;
		},
		subrubro() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.subrubro;
			else return this.$store.state.pedidos.subrubro;
		},
		linea() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.linea;
			else return this.$store.state.pedidos.linea;
		},
		marca() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.marca;
			else return this.$store.state.pedidos.marca;
		},
		loadingproducto() {
			if (this.modulo === 'ocompra') return this.$store.state.ordenescompra.loadingproducto;
			else return this.$store.state.pedidos.loadingproducto;
		},
		activeProfile() {
			return this.$store.state.perfil.activeProfile;
		},
		activeHost() {
			return this.$store.state.perfil.activeHost;
		},
		cooperativa() {
			return this.$store.state.config.cuit;
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		singular: function (name) {
			return name.substring(name.length, name.length - 2) === 'es' ? name.substring(0, name.length - 2) : name.substring(0, name.length - 1);
		},
	},
	methods: {
		apply() {
			// seteá lo que necesites de paginación acá:
			const start = 0,
				limit = 12,
				page = 1;
			const patron = this.filter.patron || '';

			this.$store.dispatch('applyFilters', {
				filtros: { ...this.filter },
				start,
				limit,
				page,
				patron,
			});
		},
		//Para limpiar filtros individuales
		clearFilter(field) {
			if (!field) return;
			this.$set(this.filter, field, '');

			this.apply();
		},
		onClear(father) {
			switch (father) {
				case 'familia':
					this.filter.subfamilia_id = '';
					break;
				case 'rubro':
					this.filter.subrubro_id = '';
					break;
			}
			this.apply();
		},
		reset() {
			//this.$refs['filter'].resetFields();
			//TODO: ver pq no puedo hacer andar la función
			this.filter.familia_id = '';
			this.filter.subfamilia_id = '';
			this.filter.negocio_id = '';
			this.filter.presentacion_id = '';
			this.filter.rubro_id = '';
			this.filter.subrubro_id = '';
			this.filter.linea_id = '';
			this.filter.marca_id = '';
			this.filter.es_nuevo = false;
			this.filter.es_promocion = false;
			this.apply();
		},
		redirect(id) {
			this.$store.dispatch('loadProducto', id);
			//this.$router.push(`/${this.activeProfile}/pedidos/detalle/${id}`);
			this.$router.push(`/1/pedidos/detalle/${id}`);
		},
		setDashboard(value) {
			this.dashboard = value;
		},
		// displayCarrito() {
		// 	this.$store.dispatch('loadTorigen');
		// 	this.$store.dispatch('loadDentregas');
		// 	this.visibleCarrito = !this.visibleCarrito;
		// },
		// displayHistorial() {
		// 	this.$router.push(`/${this.activeProfile}/pedidos/historial`);
		// },
		/*goBack() {
			commit('setTotalComprados', response.data.total);
		},*/
		changepage(ps) {
			this.start = ps * this.limit - this.limit;
			this.page = ps;

			this.callProductos();
		},
		loadSelect(event, method) {
			this.loadingSelect = true;
			if (event) this.$store.dispatch(method, this.filter).then(asd => (this.loadingSelect = false));
		},
	},
	mounted() {
		//this.$store.dispatch('loadEntitityData').then(() => {
		this.apply();
		// this.callProductos();
		if (this.modulo === 'ocompra') this.$store.dispatch('loadCarritoOrdenes');
		else this.$store.dispatch('loadCarrito');
		//});
	},
};
